import { Img } from "components";
import Wrapper from "../components/Wrapper";
import AudioPlayer from "../components/AudioPlayer";
import { useState } from "react";

const videoLinks = [
  {
    url: "https://soomuch.blob.core.windows.net/data-soomuch/DemoContent/AvatarVideos/social-hub-strategy.mp4",
  },
];

const CARD_1_LANG = [
  // { url: "https://soomuch.blob.core.windows.net/data-soomuch/DemoContent/DemoEvents/ramanujan_podcast.wav", title: "English" },
  {
    url: "https://soomuch.blob.core.windows.net/data-soomuch/DemoContent/DemoEvents/ramanujan_podcast.wav",
    title: "Telugu",
  },
  {
    url: "https://soomuch.blob.core.windows.net/data-soomuch/DemoContent/DemoEvents/ramanujan_podcast-hin.wav",
    title: "Hindi",
  },
];

const CARD_2_LANG = [
  // { url: "https://soomuch.blob.core.windows.net/data-soomuch/DemoContent/DemoEvents/podcast_demo.wav", title: "English" },
  {
    url: "https://soomuch.blob.core.windows.net/data-soomuch/DemoContent/DemoEvents/podcast_demo.wav",
    title: "Telugu",
  },
  {
    url: "https://soomuch.blob.core.windows.net/data-soomuch/DemoContent/DemoEvents/podcast_demo-hin.wav",
    title: "Hindi",
  },
];

const SocialHub = () => {
  const [lang, setLang] = useState({
    card1: CARD_1_LANG?.[0]?.url,
    card2: CARD_2_LANG?.[0]?.url,
  });

  const handleLang = (language, changeFor) => {
    setLang((lang) => ({
      ...lang,
      [changeFor]: language,
    }));
  };

  return (
    <Wrapper
      title={"Social Hub"}
      addSubTitle={
        <div className="flex gap-3 justify-center items-center">
          <Img
            src={"images/soomuch-demo/facebook.svg"}
            className="max-h-[3.5vh]"
          />
          <Img
            src={"images/soomuch-demo/instagram.svg"}
            className="max-h-[3.5vh]"
          />
          <Img
            src={"images/soomuch-demo/youtube.svg"}
            className="max-h-[3.5vh]"
          />
        </div>
      }
      description={
        <>
          Stay ahead with AI-powered daily updates tailored for your child's
          learning journey. Get expert <br /> parent support and insights to
          nurture growth every step of the way.
        </>
      }
      videoLinks={videoLinks}
      body={
        <>
          <div className="flex flex-col items-between justify-center text-center">
            <div className="grid grid-cols-3 gap-[2vh]">
              <div className="col-span-2">
                <h2 className="text-[3vh] text-center font-manropeB text-smd_blue-normal mt-2">
                  Social Media Magic, Engage Daily
                </h2>
              </div>
              <div>
                <h2 className="text-[3vh] text-center font-manropeB text-smd_blue-normal mt-2">
                  Child Counsellor Program
                </h2>
              </div>

              <div className="p-[1.6vh] flex flex-col justify-center gap-y-3 text-[2.4vh] bg-smd_white-light border-2 border-[#FBF1E7] rounded-3xl shadow-sm w-full backdrop-blur-sm">
                <div className="grid grid-cols-2">
                  <div className="font-light text-left space-y-6">
                    <p>
                      <span className="font-manropeSB">70+ Celebrations</span>{" "}
                      <br />
                      Celebrate every festival
                    </p>
                    <p>
                      AI instantly{" "}
                      <span className="font-manropeSB">
                        send
                        <br /> personalized wishes
                      </span>{" "}
                      to all parents
                    </p>
                    <p>
                      Automatically{" "}
                      <span className="font-manropeSB">
                        creates <br />
                        posts, captions, <br />
                        hashtags and festive <br /> reel videos in seconds.
                      </span>
                    </p>
                  </div>
                  <div className="space-y-2">
                    <span className="font-manropeSB">Sample Reel</span>
                    <Img
                      src="https://soomuch.blob.core.windows.net/data-soomuch/DemoContent/DemoEvents/sample_festival_reel.gif"
                      className="mx-auto object-cover h-[45vh] rounded-xl"
                    />
                    {/* <VideoReel
                      src="/your-video-file.mp4"
                      poster="images/soomuch-demo/ReelVideo1.svg"
                      title="Children creating traditional rangoli art"
                    /> */}
                    {/* <video
                      src={AVATAR_LINKS?.[videoSufflinigPostion]?.url}
                      playsInline
                      disablePictureInPicture  // 🔒 Disables PiP across Chromium browsers
                      controlsList="nodownload nofullscreen noplaybackrate noremoteplayback" // Optional: further restricts controls
                      className="w-[20vh] h-[20vh] object-top object-cover bg-[white] rounded-lg blur-sm"
                    /> */}
                  </div>
                </div>
              </div>

              <div className="relative z-[10] p-[1.6vh] flex flex-col justify-center gap-y-3 text-[2.4vh] bg-smd_white-light border-2 border-[#FBF1E7] rounded-3xl shadow-sm w-full backdrop-blur-sm">
                <div className="absolute top-1/2 -right-[5vh]">
                  <div className="flex justify-center items-center w-[8vh] h-[8vh] bg-[white] border-2 border-[#FBF1E7] -translate-y-1/2 rounded-full shadow-md">
                    <Img
                      src="images/soomuch-demo/OrangeAdd.svg"
                      className="h-[5vh]"
                    />
                  </div>
                </div>
                <div className="grid grid-cols-2">
                  <div className="flex flex-col justify-between font-light text-left">
                    <div className="space-y-4">
                      <p className="font-manropeSB">
                        365 Days of <br /> Inspiration
                      </p>
                      <p>
                        Your child will begin every <br />
                        morning with new topic
                      </p>
                    </div>
                    <div className="space-y-2">
                      {/* <select className="mb-2 w-fit bg-smd_white-light border-2 border-[#FBF1E7] rounded-2xl text-[2.5vh] text-[#484848] py-1 px-2 focus:outline-none focus:ring-0 focus:border-smd_golden-light" onChange={e => handleLang(e.target.value, "card1")} defaultValue={lang?.card1}>
                        {CARD_1_LANG?.map((item, index) => <option key={"asdkbakssdasdasd"+index} disabled={!item?.url} value={item?.url}>{item?.title}</option>)}
                      </select> */}
                      <span className="font-manropeSB">
                        Sample Audio <br />
                        Podcast
                      </span>
                      {/* <div className="flex flex-wrap items-center gap-2"> */}
                      <AudioPlayer
                        showWavesDefault
                        wavesWitdh="w-[80%]"
                        autoWidth={"w-full"}
                        title={CARD_1_LANG?.[0]?.title}
                        src={CARD_1_LANG?.[0]?.url}
                      />
                      <AudioPlayer
                        showWavesDefault
                        wavesWitdh="w-[80%]"
                        autoWidth={"w-full"}
                        title={CARD_1_LANG?.[1]?.title}
                        src={CARD_1_LANG?.[1]?.url}
                      />
                      {/* <AudioPlayer showWavesDefault wavesWitdh="w-[80%]" autoWidth={"w-full"} title={CARD_1_LANG?.[2]?.title} src={CARD_1_LANG?.[2]?.url} /> */}
                      {/* </div> */}
                    </div>
                  </div>
                  <div className="space-y-2">
                    <span className="font-manropeSB">Sample Reel</span>
                    <Img
                      src="https://soomuch.blob.core.windows.net/data-soomuch/DemoContent/DemoEvents/ramanujan.gif"
                      className="mx-auto h-[45vh] object-cover rounded-xl"
                    />
                  </div>
                </div>
              </div>
              <div className="z-[0] text-left p-[1.7vh] flex flex-col justify-center gap-y-3 text-[2.4vh] bg-smd_white-light border-2 border-[#FBF1E7] rounded-3xl shadow-sm w-full backdrop-blur-sm">
                <p>
                  We have{" "}
                  <span className="font-manropeSB">identified 15 common</span>{" "}
                  problems faced by <br /> parents during their child’s
                  education. Solutions will <br /> be provided through
                  content like{" "}
                  <span className="font-manropeSB">
                    Articles, videos, and podcasts.
                  </span>
                </p>
                <Img src="images/soomuch-demo/VideoPodCastComingSoon.svg" />
                <div className="space-y-2 overflow-clip">
                  <span className="font-manropeSB">Sample Audio Podcast</span>
                  {/* <div className="flex items-center justify-between">
                    <select className="w-fit bg-smd_white-light border-2 border-[#FBF1E7] rounded-2xl text-[2.5vh] text-[#484848] py-1 px-2 focus:outline-none focus:ring-0 focus:border-smd_golden-light" onChange={e => handleLang(e.target.value, "card2")} defaultValue={lang?.card2}>
                      {CARD_2_LANG?.map((item, index) => <option key={"asdkbaksjdbasdasdasd" + index} disabled={!item?.url} value={item?.url}>{item?.title}</option>)}
                    </select>
                  </div> */}
                  <div className="flex items-center gap-4">
                    <AudioPlayer
                      title={CARD_2_LANG?.[0]?.title}
                      src={CARD_2_LANG?.[0]?.url}
                    />
                    <AudioPlayer
                      title={CARD_2_LANG?.[1]?.title}
                      src={CARD_2_LANG?.[1]?.url}
                    />
                    {/* <AudioPlayer title={CARD_2_LANG?.[2]?.title} src={CARD_2_LANG?.[2]?.url} /> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      }
    />
  );
};
export default SocialHub;
